import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatCardModule } from "@angular/material/card";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatListModule } from "@angular/material/list";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatChipsModule } from "@angular/material/chips";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { BaseChartDirective } from "ng2-charts";
import { AppComponent } from "./app.component";
import { AppCompanyMigrationComponent } from "./views/company-migration/company-migration.component";

// Import from Okta Angular SDK
import { OktaAuthModule, OktaAuthGuard, OKTA_CONFIG } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";

import environment from "../environments/environment";
import { TableGridComponent } from "./components/table-grid/table-grid/table-grid.component";
import { SearchSelectComponent } from "./components/search-list-box/search-select.component";
import { AuthInterceptor } from "./interceptors/auth.interceptor";

import { MatDialogModule } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { ToastComponent } from "./components/toast-component/toast.component";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { MigrationsComponent } from "./views/migrations/migrations.component";
import { AutoToogleComponent } from "./components/auto-toogle/auto-toogle.component";
import { MigrationDetailsComponent } from "./views/migration-detail/migration-details.component";
import { ProgressTrackerComponent } from "./components/progress-tracker/progress-tracker.component";
import { FalloutTrackerComponent } from "./views/fallout-tracker/fallout-tracker.component";
import { StatisticsComponent } from "./views/statistics/statistics.component";
import { QueuedMigrationsComponent } from "./views/queued-migrations/queued-migrations.component";

//Create OktaAuth instance
const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: environment.okta.redirectUri,
  scopes: environment.okta.scopes,
  tokenManager: {
    storage: "localStorage",
  },
});

@NgModule({
  declarations: [
    AppComponent,
    AppCompanyMigrationComponent,
    MigrationsComponent,
    TableGridComponent,
    SearchSelectComponent,
    ConfirmDialogComponent,
    ToastComponent,
    AutoToogleComponent,
    MigrationDetailsComponent,
    ProgressTrackerComponent,
    FalloutTrackerComponent,
    StatisticsComponent,
    QueuedMigrationsComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatToolbarModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatChipsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatGridListModule,
    MatExpansionModule,
    MatTabsModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    BaseChartDirective,
    OktaAuthModule,
  ],
  //providers: [{ provide: OKTA_CONFIG, useValue: { oktaAuth } }, OktaAuthGuard],
  providers: [
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    OktaAuthGuard,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
